import request from '@/utils/request'
// 获取轮播图
export function getHomeData(data) {
  return request({
    url: '/m16835/6979c6a2808da',
    method: 'post',
    data
  })
}
// 订单查询
export function getOrderList(data) {
  return request({
    url: '/m16835/6979734b61659',
    method: 'post',
    data
  })
}
// 订单详情查询
export function getOrderDetail(data) {
  return request({
    url: '/m16835/69797a4142cfb',
    method: 'post',
    data
  })
}